import React from 'react';
import { Tag } from 'antd';

interface Props {
  label: string;
  onClose: () => void;
  style?: React.CSSProperties;
}

const FilterChip = ({ label, onClose, style }: Props) => {
  return (
    <Tag style={style} closable onClose={onClose}>
      {label}
    </Tag>
  );
};

export default FilterChip;
